module.exports = __webpack_public_path__ + "img/step-1.10def36f.svg";